import { transformRoutes } from '@backoffice-frontend/common'

const BaseUpdatesAreaRoutes = {
  route: '/updates',
}

export const UpdatesAreaRoutes = transformRoutes(BaseUpdatesAreaRoutes)
